import { render, staticRenderFns } from "./cloud.vue?vue&type=template&id=c2089656&scoped=true&"
import script from "./cloud.vue?vue&type=script&lang=js&"
export * from "./cloud.vue?vue&type=script&lang=js&"
import style0 from "./cloud.vue?vue&type=style&index=0&id=c2089656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2089656",
  null
  
)

export default component.exports